import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const state = {
	// 存到localStorage storeFlag=1
	APP_TYPE:0,
	user: '', // 用户信息
selectFooter:'',//标识进入的模块，加载不同的footer  energy,operation,service
	// energy
	energy_room: '', // energy首页
	companyInfo:'',  //select页面用户选择公司的问题
	//operation
	//HomeCustomer
	HCmeterType:[],
	// 不存到localStorage
	// energy
	videoToken:'',//个人中心视频监控的权限是否可见
	//operation
	oTaskReleaseContent: { //发布任务
		oTaskType: '', //选择任务类型
		oTRcompany: '', //发布任务选择客户时，页面传值
		oTaskname: '',
		oTRarchiveArr: '', //发布任务选择设备页面，页面传值，/operation/TREquipmentList到/operation/TaskREContentList
		oTRarchiveItemArr: '', //下一步设备传值
		oTRImages: [], //发布任务图片
		oTRtime: '',
		oTRcontent: '',
		projecter:'' //负责人
	},

	TaskProcessTab: '', //任务处理/operation/TaskProcess,保留tab
	TaskProcessData: '', //任务处理/operation/TaskProcess,保留data,解决任务详情页面返回上一页，页面为空，过了1、2秒才显示任务列表
	homeElectricianTab: '', //电工首页/operation/HomeElectrician,保留tab
	oTaskIndexCount:[], //任务处理/operation/Task，保留任务数

	visitFollowList:[]//新的业务机会

}
export default new Vuex.Store({
	state,
	mutations,
	getters
})

//	//import storeState from '@/store'
//	storeState.commit({
//	        type:"setState",
//	        attr:'oTRcompany',
//	        value: json,
//	        storeFlag: 1
//	});


// storeState.state.oTRcompany
// storeState.getters.getState('')
// storeState.getters.getState('user').user_id


// WEBPACK FOOTER //
// ./src/store/index.js